import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
@Component({
  selector: 'app-transfer-course',
  templateUrl: './transfer-course.component.html',
  styleUrls: ['./transfer-course.component.scss']
})
export class TransferCourseComponent implements OnInit {
  TransferCourse: FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  SessionNo: any;
  constructor(public umsService: UmsService,public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.TransferCourse = this.fb.group({
      list: new FormControl(),
      list2: new FormControl(),
      list3: new FormControl(),
      Colg: new FormControl(),
      Debar: new FormControl(),
      Chng: new FormControl(),
      Batch: new FormControl(),
      HonsSub: new FormControl(),
      RgNo: new FormControl(),
      Name: new FormControl(),
      ColgCd: new FormControl(),
      CancTrf: new FormControl(),
      Exam: new FormControl(),
      Valid: new FormControl(),
      Valid1: new FormControl(),

    })
  }
  
  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }


  fetchList() {
    let payload = {}
    payload["SnNo"] =  this.SessionNo;
    payload["InCode"] = 7;
    payload["OpId"] = sessionStorage.getItem('userId');
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMarks = res.data;
        this.filteredListOfMarks = this.ListOfMarks.slice();
      }
      else {

      }

    });

  }
}
